<div class="pagination-container d-flex justify-content-between align-items-center mt-3 flex-wrap">
  <!-- Records per page selector -->
  <div class="page-size-selector mb-2 mb-sm-0 d-flex align-items-center ">
    <label>Records per page:</label>
    <select [(ngModel)]="pageSize" (change)="onPageSizeChange(pageSize)">
      <option *ngFor="let size of pageSizeOptions" [value]="size">{{ size }}</option>
    </select>
  </div>

  <!-- Pagination Buttons -->
  <div class="pagination-buttons d-flex align-items-center flex-wrap gap-1">
    <!-- First Page Button -->
    <button 
      class="btn btn-sm btn-outline-secondary"
      [disabled]="currentPage === 1"
      (click)="onPageClick(1)"
      title="First Page">
      <img src="assets/images/first.svg" alt="First" class="pagination-icon">
    </button>

    <!-- Previous Page Button -->
    <button 
      class="btn btn-sm btn-outline-secondary"
      [disabled]="currentPage === 1"
      (click)="prevPage()"
      title="Previous Page">
      <img src="assets/images/prev.svg" alt="Previous" class="pagination-icon">
    </button>

    <!-- Page Numbers -->
    <ng-container *ngFor="let page of getVisiblePages()">
      <button 
        *ngIf="page !== '...'; else dots"
        class="btn btn-sm"
        [class.btn-primary]="page === currentPage"
        [class.btn-outline-secondary]="page !== currentPage"
        (click)="onPageClick(page)">
        {{ page }}
      </button>

      <ng-template #dots>
        <span class="btn btn-sm btn-light" disabled>...</span>
      </ng-template>
    </ng-container>

    <!-- Next Page Button -->
    <button 
      class="btn btn-sm btn-outline-secondary"
      [disabled]="currentPage === totalPages"
      (click)="nextPage()"
      title="Next Page">
      <img src="assets/images/next.svg" alt="Next" class="pagination-icon">
    </button>

    <!-- Last Page Button -->
    <button 
      class="btn btn-sm btn-outline-secondary"
      [disabled]="currentPage === totalPages"
      (click)="onPageClick(totalPages)"
      title="Last Page">
      <img src="assets/images/last.svg" alt="Last" class="pagination-icon">
    </button>
  </div>
</div>
